module.exports = __webpack_public_path__ + "static/media/logo2.10daf439.svg";